// Builder data footer brand (PURE) — dipakai BrandFooter (klien) DAN renderer
// statis (server), supaya HTML statis == tampilan React (anti-drift).
import type { BusinessInfo, Warehouse } from '../../types';
import { DUMMY } from './dummy';

export interface BrandFooterData {
    businessName: string;
    logo: string;
    address: string;
    contactEmail: string;
    contactPhone: string;
    operationHours: string;
    country: string;
    policies: BusinessInfo;
}

const brandSlug = (name: string) => name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');

export function buildBrandFooterData(row: any): BrandFooterData | null {
    if (!row) return null;
    const bi = (row.businessInfo || {}) as BusinessInfo;
    const warehouses = Array.isArray(row.warehouses) ? (row.warehouses as Warehouse[]) : [];
    const defaultWarehouse = warehouses.find((w) => w.isDefault) || warehouses[0];
    const brandName = row.name || 'Toko Kami';
    const slug = brandSlug(brandName);

    return {
        businessName: bi.businessName || brandName,
        logo: row.logo || '',
        address: bi.address || (defaultWarehouse ? [defaultWarehouse.name, defaultWarehouse.address].filter(Boolean).join(' - ') : '') || '',
        contactEmail: bi.contactEmail || row.supportEmail || DUMMY.email(slug),
        contactPhone: bi.contactPhone || row.complaintPhone || DUMMY.phone,
        operationHours: bi.operationHours || (row.country === 'MY' ? 'Isnin - Sabtu, 08.00 - 17.00 MYT' : DUMMY.hours),
        country: row.country || 'ID',
        policies: { ...DUMMY.policies, ...(Object.keys(bi).length ? bi : {}) },
    };
}
